.root {
    --color: #000;
    --color-2: #fff;

    position: relative;
    aspect-ratio: 394/250;
    overflow: hidden;
    z-index: 1;
    text-align: left;

    svg {
        position: absolute;
        width: 100%;
        height: 100%;
    }
}

.outline {
    z-index: 2;

    path {
        fill: var(--color);
    }
}

.s {
    z-index: 0;

    path {
        fill: var(--color);
    }
}

.gradient {
    position: absolute;
    inset: 0;
    z-index: 1;
    clip-path: polygon(0% 18%, 50% 6%, 100% 18%, 100% 79%, 50% 93.5%, 0 79%);
    background: linear-gradient(-90deg, var(--color) 50%, var(--color-2) 50%);
    background-size: 200% 100%;
    animation: pulse 4s ease-in-out infinite;
    mix-blend-mode: difference;
}

.backdrop {
    position: absolute;
    inset: 0;
    z-index: -1;
    clip-path: polygon(0% 18%, 50% 6%, 100% 18%, 100% 79%, 50% 93.5%, 0 79%);
    background: var(--white);
}

@keyframes pulse {
    0% {
        background-position: 100% 100%;
    }

    60% {
        background-position: 0% 0%;
    }

    80% {
        background-position: 0% 0%;
    }

    90% {
        background-position: 100% 100%;
    }

    100% {
        background-position: 100% 100%;
    }
}
